<template>
  <div class="fixed_right" v-if="rightBtn">
    <div class="right_bottom">
      <el-popover trigger="hover" :width="460" popper-class="kefu_pop" placement="left">
        <div class="kefuBox">
          <img class="kefuLef" src="./img/kfnImg.png"></img>
          <div class="kefuRigbox">
            <div class="kefuTitText">客服在线</div>
            <div class="kefuTimeTip">
              客服在线时间：上午8:30-11:30，下午14:00-18:00
            </div>
            <div :class="isOnline=='在线'?'kefuTimeCur animated-yes':'kefuTimeCur animated-no'">
              当前人工客服{{ isOnline }}，{{ isOnline == '在线' ? '有问题请' : '请稍后咨询或去' }}→
              <div class="tokefuBtn" @click="toKf()">{{ isOnline == '在线' ? '人工客服' : '留言' }}</div>
            </div>
          </div>
        </div>
        <template #reference>
          <div class="btn_item" @mouseover="checkOnlineStatus()">
            <div class="ico_close" @click="closeKf">×</div>
            <div class="zxzx">
              在线咨询
            </div>
          </div>
        </template>
      </el-popover>

    </div>
  </div>
</template>

<script>
export default {
  data(){
    return{
      rightBtn:false,
      isOnline:'在线'
    }
  },
  created(){
    console.log('执行');

    this.checkTimestamp()
  },
  methods:{
    closeKf(){
      localStorage.setItem('kfPopdate',JSON.stringify({time:Date.now()}))
      this.rightBtn=!this.rightBtn
    },
    checkTimestamp() {
      // if(localStorage.getItem('kehuTip')){
      let kehuInfo = localStorage.getItem('kfPopdate')
      if(!kehuInfo){
        this.rightBtn = true
        return
      }
      kehuInfo = JSON.parse(kehuInfo)
      let start_time = kehuInfo.time
      const TWELVE_HOURS = 12 * 60 * 60 * 1000; // 12小时的毫秒数
      const currentTime = Date.now();

      // 计算时间差
      const timeDiff = currentTime - parseInt(start_time, 10);

      // 超过12小时执行操作
      if (timeDiff >= TWELVE_HOURS) {
        this.rightBtn = true
      }else{
        this.rightBtn = false
      }
      // }
    },
    toKf(){
      window.open(SITE_BTN_CONFIG.kefu_url.btn_value)
    },
    checkOnlineStatus(){
      const now = new Date();
      const hours = now.getHours();
      const minutes = now.getMinutes();
      const totalMinutes = hours * 60 + minutes;

      // 时间范围配置（分钟数计算）
      const morningStart = 8 * 60 + 30;  // 08:30 → 510
      const morningEnd = 11 * 60 + 30; // 11:30 → 690
      const afternoonStart = 14 * 60; // 14:00 → 840
      const afternoonEnd = 18 * 60;  // 18:00 → 1080

      // 判断当前是否在时间范围内
      const isOn = (totalMinutes >= morningStart && totalMinutes <= morningEnd) ||
          (totalMinutes >= afternoonStart && totalMinutes <= afternoonEnd);

      this.isOnline = isOn ? '在线' : '不在线';
    }
  }

}
</script>

<style lang="scss" scoped>
.fixed_right {
  position: fixed;
  right: 22px;
  bottom: 100px;
  z-index: 90;

  .news_btn {
    padding: 5px 13px;

    img {
      text-align: center;
      width: 20px;
      height: 20px;
    }
  }

  .right_bottom {
    border-radius: 50%;
    box-shadow: 0 2px 10px 0 rgba(75, 91, 138, .1);


    .btn_bor_bot {
      border-bottom: 1px dashed #ccc;
    }

    .btn_item {
      cursor: pointer;
      display: block;
      width: 50px;
      height: 50px;
      border-radius: 50%;
      background: #ccc;
      background: url('./img/kfnImg.png') no-repeat;
      background-size: contain;
      position: relative;
      border: 2px solid #ffc518;
      .zxzx{
        position: absolute;
        bottom: -15px;
        left: 50%;
        transform: translateX(-50%);
        background-color:  #ffcf40;
        color: black;
        font-size: 11px;
        width: 50px;
        padding: 3px 0;
        border-radius: 4px;
        text-align: center;
      }
      .ico_close{
        padding: 10px;
        color: #fff;
        position: absolute;
        top: -15px;
        right: -5px;
        border-radius: 50%;
        width: 15px;
        height: 15px;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        font-size: 24px;
        display: none;

      }

      &:hover{
        .ico_close{
          display: flex !important;
        }
      }
      .btn_icon {
        display: block;
      }

      .btn_text {
        color: black;
        line-height: 28px;
        font-size: 14px;
      }

      .weidu {
        position: absolute;
        top: 30px;
        left: -115px;
      }
    }
  }

}

.kefuBox{
  display: flex;
  align-items: center;
  padding: 10px;
  .kefuLef{
    width: 100px;
    height: 100px;
  }

  .kefuRigbox{
    margin-left: 20px;
    .kefuTitText{
      font-size: 20px;
      font-weight: 600;
      color: #000;
    }
    .kefuTimeTip{
      color: #000;
      margin-top: 10px;
    }
    .kefuTimeCur{
      display: flex;
      align-items: center;
      justify-content: space-between;
      color: #000;
      margin-top: 10px;
      .tokefuBtn{
        border-radius: 6px;
        background: #000;
        color: #fff;
        font-size: 14px;
        padding: 5px 10px;
        cursor: pointer;
      }
    }
  }
  .animated-yes{
    animation: colorChange 1s infinite;
  }

  .animated-no{
    animation: colorChangeNo 1s infinite;
  }
}

@keyframes colorChange {
  0% {
    color: #07c160;
  }
  100% {
    color: #fff;
  }
}

@keyframes colorChangeNo {
  0% {
    color: #ec3b3b;
  }
  100% {
    color: #fff;
  }
}

.kefu_pop{
  margin-right: 20px !important;
  box-shadow: 0 2px 12px 0 rgba(0,0,0,.1) !important;
}
</style>

<style lang="scss">
.kefu_pop{
  padding: 0 !important;
  background: #fff !important;

}
</style>